import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=c7a01abc&scoped=true&lang=pug&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=c7a01abc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a01abc",
  null
  
)

export default component.exports